<div class="footer-group left">
  @if (data?.cancel) {
    <div class="modal-button">
      <myre-button
        (onClick)="click('cancel')"
        [label]="data.cancel | translate"
        [theme]="ButtonTheme.Secondary"
        id="cancel"
      />
    </div>
  }

  @if (data?.delete) {
    <div class="modal-button">
      <myre-button
        (onClick)="click('delete')"
        [label]="data.delete.label | translate"
        [theme]="ButtonTheme.Secondary"
        [subTheme]="ButtonSubTheme.Red"
        [icon]="data.delete.withIcon ? 'delete' : null"
        id="delete"
      />
    </div>
  }
</div>

<div class="footer-group center">
  @if (data?.close) {
    <div class="modal-button">
      <myre-button
        (onClick)="click('close')"
        [label]="data.close | translate"
        [theme]="ButtonTheme.Secondary"
        id="close"
      />
    </div>
  }
</div>

<div class="footer-group right">
  @if (data?.no) {
    <div class="modal-button">
      <myre-button
        (onClick)="click('no')"
        [label]="data.no | translate"
        [theme]="ButtonTheme.Secondary"
        id="no"
      />
    </div>
  }

  @if (data?.yes) {
    <div class="modal-button">
      <myre-button
        (onClick)="click('yes')"
        [label]="data.yes | translate"
        id="yes"
      />
    </div>
  }

  @if (data?.ok) {
    <div class="modal-button">
      <myre-button
        [disabled]="(isLoading$ | async) || okDisabled()"
        [label]="data.ok | translate"
        [isLoading]="data.okLoading && data.okLoading()"
        [type]="ButtonType.Submit"
        id="ok"
      />
    </div>
  }

  @if (data?.confirmWarning) {
    <div class="modal-button">
      <myre-button
        [label]="data.confirmWarning | translate"
        [theme]="ButtonTheme.Primary"
        [subTheme]="ButtonSubTheme.Red"
        [type]="ButtonType.Submit"
        id="confirmWarning"
      />
    </div>
  }

  @if (data?.confirmInfo) {
    <div class="modal-button">
      <myre-button
        [label]="data.confirmInfo | translate"
        [type]="ButtonType.Submit"
        id="confirmInfo"
      />
    </div>
  }
</div>
